import MainLayout from '@/common/components/layouts/MainLayout';
import { PropsWithChildren } from 'react';

export default ({ children }: PropsWithChildren) => {
  return (
    <MainLayout title="بیمه گذار / حساب بانکی" header="titleHeader">
      {children}
    </MainLayout>
  );
};
